import { NotificationMenuItem } from './notifications-types';

export const NotificationStatus = {
  Queued: 0,
  InProgress: 1,
  Done: 2,
  Error: 3
};

export const ResourceTypes = {
  Template: 0,
  Form: 1,
  DataSource: 2,
  Workflow: 3,
  WorkflowJob: 4,
  App: 5
};

export const MENU_ITEM: NotificationMenuItem[] = [
  { index: 0, name: 'All' },
  { index: 1, name: 'Unread' }
];
